import React, { useEffect, useState } from 'react';
import DownloadAppComponent from 'src/app/components/commonComponents/DownloadAppComponent';
import ProfileLayout from 'src/app/layouts/ProfileLayout';
import LocalImages from 'src/app/static';

const DownloadAppScreen = () => {
    const [height, setHeight] = useState('100vh');
    const updateHeight = () => {
        const windowHeight = window.innerHeight;
        const newHeight = `calc(${windowHeight}px - 104px)`;
        setHeight(newHeight);
    };
    
    useEffect(() => {
        updateHeight();
        window.addEventListener('resize', updateHeight);
    
        return () => {
          window.removeEventListener('resize', updateHeight);
        };
      }, [updateHeight]);
    return (
        <ProfileLayout>
            <div className='d-flex justify-content-center align-items-center' style={{ height: height }}>
                <div>
                    <div className='mx-auto download-app'>
                        <img alt="download-app" src={LocalImages.downloadAppScreen} className="img-fluid" />
                    </div>
                    <DownloadAppComponent isLoginScreen={false} />
                </div>
            </div>
        </ProfileLayout>
    )
};

export default DownloadAppScreen;